import type { FeatureGrant, PractitionerRoleType } from "~/enums/role";
import type { FullAccessTokenResponse } from "~/types/oauth";
import type { LocationIdentifier } from "~/types/api";
import type { ApiRequestHelpers } from "./useHttpClient";
import type { PractitionerIdentifier, PractitionerProfile, Response, UpdatePractitionerProfilePayload } from "~/types/api";

export function createPractitionerApi({ getRequest, putRequest, postRequest }: ApiRequestHelpers) {
  const practitionerProfile = (practitionerId: PractitionerIdentifier) =>
    getRequest<Response<PractitionerProfile>>(`/practitioners/${practitionerId}`);

  const updatePractitionerProfile = (
    practitionerId: PractitionerIdentifier,
    data: UpdatePractitionerProfilePayload,
  ) => putRequest<Response<PractitionerProfile>>(`/practitioners/${practitionerId}`, data);

  const syncPractitionerRoles = (practitionerId: PractitionerIdentifier, locationId: LocationIdentifier, roleTypes: PractitionerRoleType[]) =>
    putRequest<Response<{ id: number; full_name: string; email: string; roles: PractitionerRoleType[] }>>(`/practitioners/${practitionerId}/roles`, { location_id: locationId, role_types: roleTypes });

  const syncFeatureGrants = (locationId: LocationIdentifier, userId: number, grants: FeatureGrant[]) =>
    putRequest<Response<{ grants: FeatureGrant[] }>>(`/locations/${locationId}/users/${userId}/feature-grants`, { grants });

  const impersonatePractitioner = (practitionerId: PractitionerIdentifier) =>
    postRequest<FullAccessTokenResponse & { token: { expires_at: string } }>(`/practitioners/${practitionerId}/impersonate`);

  return {
    syncPractitionerRoles,
    syncFeatureGrants,
    impersonatePractitioner,
    practitionerProfile,
    updatePractitionerProfile,
  };
}

export type PractitionerApi = ReturnType<typeof createPractitionerApi>;
